var _path, _path2, _path3, _path4, _path5, _path6, _path7;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInternetBulk(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13.25C12.4142 13.25 12.75 13.5858 12.75 14V17C12.75 17.4142 12.4142 17.75 12 17.75C11.5858 17.75 11.25 17.4142 11.25 17V14C11.25 13.5858 11.5858 13.25 12 13.25Z",
    fill: "#464555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.25 19C21.25 19.4142 20.9142 19.75 20.5 19.75L14 19.75C13.5858 19.75 13.25 19.4142 13.25 19C13.25 18.5858 13.5858 18.25 14 18.25L20.5 18.25C20.9142 18.25 21.25 18.5858 21.25 19Z",
    fill: "#464555"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.25 19C11.25 19.4142 10.9142 19.75 10.5 19.75L4 19.75C3.58579 19.75 3.25 19.4142 3.25 19C3.25 18.5858 3.58579 18.25 4 18.25L10.5 18.25C10.9142 18.25 11.25 18.5858 11.25 19Z",
    fill: "#464555"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 19.25C12.4142 19.25 12.75 19.5858 12.75 20V22C12.75 22.4142 12.4142 22.75 12 22.75C11.5858 22.75 11.25 22.4142 11.25 22V20C11.25 19.5858 11.5858 19.25 12 19.25Z",
    fill: "#464555"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M18 8C18 11.3137 15.3137 14 12 14C8.68629 14 6 11.3137 6 8C6 4.68629 8.68629 2 12 2C15.3137 2 18 4.68629 18 8Z",
    fill: "#464555"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M14 19C14 17.8954 13.1046 17 12 17C10.8954 17 10 17.8954 10 19C10 20.1046 10.8954 21 12 21C13.1046 21 14 20.1046 14 19Z",
    fill: "#464555"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9535 8.75023H14.9909C14.9478 10.5204 14.7532 12.1569 14.4432 13.4817C16.3213 12.6433 17.6894 10.8682 17.9535 8.75023ZM12.5691 13.9734C12.636 13.7871 12.7023 13.5765 12.7666 13.3409C13.0839 12.1772 13.3055 10.5731 13.3538 8.75023H10.6462C10.6945 10.5731 10.9161 12.1772 11.2334 13.3409C11.2977 13.5765 11.364 13.7871 11.4309 13.9734C11.6182 13.991 11.8081 14 12 14C12.1919 14 12.3818 13.991 12.5691 13.9734ZM9.55678 13.4817C9.24681 12.1569 9.05218 10.5204 9.00909 8.75023H6.04645C6.31064 10.8682 7.67873 12.6433 9.55678 13.4817ZM12 2C8.71218 2 6.04201 4.64448 6.00049 7.92245C6.00338 7.6951 6.01891 7.47081 6.04642 7.25023H9.00909C9.05218 5.4799 9.24683 3.84338 9.55684 2.51854C10.1385 2.2589 10.7691 2.08912 11.431 2.02686C11.3641 2.21316 11.2977 2.4239 11.2334 2.6596C10.9161 3.82324 10.6945 5.42734 10.6462 7.25023H13.3538C13.3055 5.42734 13.0839 3.82324 12.7666 2.6596C12.7023 2.4239 12.6359 2.21316 12.569 2.02686C13.2309 2.08912 13.8615 2.2589 14.4432 2.51854C14.7532 3.84338 14.9478 5.4799 14.9909 7.25023H17.9536C17.9762 7.43168 17.9907 7.61564 17.9968 7.80175C17.8922 4.57981 15.2474 2 12 2Z",
    fill: "#464555"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInternetBulk);
export default __webpack_public_path__ + "static/media/internetBulk.aabe214ecaad5e95d2dbfec7283ea29a.svg";
export { ForwardRef as ReactComponent };